var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 13.4375H7.89062C8.21875 13.957 8.62891 14.3945 9.12109 14.75C9.03906 14.75 8.95703 14.75 8.875 14.75H1.875C0.890625 14.75 0.125 13.9844 0.125 13V2.5C0.125 1.54297 0.890625 0.75 1.875 0.75H6.38672C6.85156 0.75 7.28906 0.941406 7.61719 1.26953L10.1055 3.75781C10.4336 4.08594 10.625 4.52344 10.625 4.98828V6.19141C10.1328 6.32812 9.69531 6.51953 9.3125 6.79297V5.125H7.125C6.63281 5.125 6.25 4.74219 6.25 4.25V2.0625H1.875C1.62891 2.0625 1.4375 2.28125 1.4375 2.5V13C1.4375 13.2461 1.62891 13.4375 1.875 13.4375ZM8 10.8125C8 9.41797 8.73828 8.13281 9.96875 7.42188C11.1719 6.71094 12.6758 6.71094 13.9062 7.42188C15.1094 8.13281 15.875 9.41797 15.875 10.8125C15.875 12.2344 15.1094 13.5195 13.9062 14.2305C12.6758 14.9414 11.1719 14.9414 9.96875 14.2305C8.73828 13.5195 8 12.2344 8 10.8125ZM13.7695 9.63672C13.6055 9.47266 13.3047 9.47266 13.1406 9.63672L11.5 11.3047L10.707 10.5117C10.543 10.3477 10.2422 10.3477 10.0781 10.5117C9.91406 10.6758 9.91406 10.9766 10.0781 11.1406L11.1719 12.2344C11.3359 12.3984 11.6367 12.3984 11.8008 12.2344L13.7695 10.2656C13.9336 10.1016 13.9336 9.80078 13.7695 9.63672Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCheck);
export default __webpack_public_path__ + "static/media/document-check.6dc61dd3b5e15ca7e534c17f7c612e53.svg";
export { ForwardRef as ReactComponent };